import React, { useEffect } from 'react';
import { Database, HardDrive, RefreshCw } from 'lucide-react';
import { useData } from '../context/DataContext';
import CategoryTabs from '../components/CategoryTabs';

const HighAvailability = () => {
  const { getContentByCategory, trackPageView } = useData();

  useEffect(() => {
    trackPageView('high-availability');
  }, [trackPageView]);

  const subcategories = [
    {
      name: 'Always On',
      icon: Database,
      description: 'Monitor Always On Availability Groups, replica health, and synchronization status.',
      scripts: getContentByCategory('High Availability', 'Always On')
    },
    {
      name: 'Backup',
      icon: HardDrive,
      description: 'Monitor backup operations, verify backup integrity, and manage backup strategies.',
      scripts: getContentByCategory('High Availability', 'Backup')
    },
    {
      name: 'Replication',
      icon: RefreshCw,
      description: 'Monitor replication health, latency, and troubleshoot replication issues.',
      scripts: getContentByCategory('High Availability', 'Replication')
    }
  ];

  return (
    <div className="page-container">
      <div className="page-header">
        <h1 className="page-title">High Availability</h1>
        <p className="page-description">
          Critical scripts for maintaining high availability and disaster recovery capabilities. 
          Monitor your HA solutions and ensure business continuity.
        </p>
      </div>

      <CategoryTabs 
        category="High Availability"
        scripts={getContentByCategory('High Availability')}
        articles={getContentByCategory('High Availability', null, 'articles')}
        faqs={getContentByCategory('High Availability', null, 'faqs')}
        subcategories={subcategories}
      />
    </div>
  );
};

export default HighAvailability;